import { Box } from '@mui/material';
import ic_analytics from 'assets/icons/ic_analytics.svg?react';
import ic_banking from 'assets/icons/ic_banking.svg?react';
import ic_blog from 'assets/icons/ic_blog.svg?react';
import ic_calendar from 'assets/icons/ic_calendar.svg?react';
import ic_cart from 'assets/icons/ic_cart.svg?react';
import ic_chat from 'assets/icons/ic_chat.svg?react';
import ic_dashboard from 'assets/icons/ic_dashboard.svg?react';
import ic_end from 'assets/icons/ic_end.svg?react';
import ic_euro from 'assets/icons/ic_euro.svg?react';
import ic_expired from 'assets/icons/ic_expired.svg?react';
import ic_group from 'assets/icons/ic_group.svg?react';
import ic_home from 'assets/icons/ic_home.svg?react';
import ic_info from 'assets/icons/ic_info.svg?react';
import ic_ingestions from 'assets/icons/ic_ingestions.svg?react';
import ic_lab from 'assets/icons/ic_lab.svg?react';
import ic_lock from 'assets/icons/ic_lock.svg?react';
import ic_mail from 'assets/icons/ic_mail.svg?react';
import ic_marketing from 'assets/icons/ic_marketing.svg?react';
import ic_news from 'assets/icons/ic_news.svg?react';
import ic_pharma from 'assets/icons/ic_pharma.svg?react';
import ic_question from 'assets/icons/ic_question.svg?react';
import ic_scan from 'assets/icons/ic_scan.svg?react';
import ic_settings from 'assets/icons/ic_settings.svg?react';
import ic_tools from 'assets/icons/ic_tools.svg?react';
import ic_user from 'assets/icons/ic_user.svg?react';
import type { FC } from 'react';

const iconByName = {
  ic_analytics,
  ic_banking,
  ic_blog,
  ic_calendar,
  ic_cart,
  ic_chat,
  ic_dashboard,
  ic_end,
  ic_euro,
  ic_expired,
  ic_group,
  ic_home,
  ic_info,
  ic_ingestions,
  ic_lab,
  ic_lock,
  ic_mail,
  ic_marketing,
  ic_news,
  ic_pharma,
  ic_question,
  ic_scan,
  ic_settings,
  ic_tools,
  ic_user,
};

type Props = {
  size?: number | string;
  name: keyof typeof iconByName;
};

const SvgIcon: FC<Props> = ({ name, size }) => {
  const Icon = iconByName[name];
  return <Box component={Icon} sx={{ display: 'inline-block', width: size, height: size }} />;
};

export default SvgIcon;
